module.exports = __webpack_public_path__ + "static/media/body.31c4dc9a.svg";